import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  listItem: {
    paddingTop: 12,
  },
});
